module.exports = {"serverUrl":"https://cqm.ustqe360.com/bk","hosturl":"http://localhost:8089/configure","scriptlessHome":"https://www.ustqe360.com/scriptless/app/home","shouldUpdateLabel":"on"}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = ./config.json
// module chunks = main